var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_12061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.655 14.3796L10.8412 13.5734L12.2502 12.1451H8.75981V10.9871H12.2502L10.8412 9.55877L11.655 8.75256L14.4683 11.5661L11.655 14.3796ZM8.30681 15.0403C7.0211 15.0403 5.92641 14.5897 5.02273 13.6884C4.11905 12.7872 3.66721 11.6937 3.66721 10.408V9.98629C2.62495 9.8508 1.75318 9.38609 1.05191 8.59217C0.350637 7.79838 0 6.85957 0 5.77575V1.3365H2.31613V0.564453H3.4742V3.26661H2.31613V2.49456H1.15807V5.77575C1.15807 6.625 1.46045 7.35201 2.06522 7.95678C2.66999 8.56155 3.397 8.86393 4.24624 8.86393C5.09549 8.86393 5.8225 8.56155 6.42727 7.95678C7.03204 7.35201 7.33442 6.625 7.33442 5.77575V2.49456H6.17636V3.26661H5.01829V0.564453H6.17636V1.3365H8.49249V5.77575C8.49249 6.85957 8.14185 7.79838 7.44058 8.59217C6.7393 9.38609 5.86754 9.8508 4.82528 9.98629V10.408C4.82528 11.3731 5.16375 12.1934 5.84071 12.8689C6.51766 13.5444 7.3397 13.8822 8.30681 13.8822V15.0403Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_12061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.9454e8a9d686b6ac9e9748f83bbd5899.svg";
export { ForwardRef as ReactComponent };